/* ZINKE Herbst Essentials — Zeichnung, Kurzinfo, Varianten, alles in den Warenkorb (28.09.2026)
   28.09. abends: Espressomaschine optional (gruenes Plus), Warenkorb nur mit gewaehlten Teilen
   28.09. spaet (Theme 9.1): feste Leiste unten am Handy, Stand „x von 7 gewaehlt“, Details-Knopf je Kachel
   29.09.: Kaufleiste auf allen Geraeten, Zeichnung passt in die erste Sicht (--zo-rest) */
(function () {
  var root = document.querySelector('[data-zo]');
  if (!root) return;

  var T = {};
  try { T = JSON.parse(root.querySelector('[data-zo-t]').textContent); } catch (e) {}
  var alle = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  /* ---------- Espressomaschine optional (28.09. abends) ---------- */
  var mitEsp = false;
  var leiste = root.querySelector('[data-zo-leiste]');
  var standEl = root.querySelector('[data-zo-stand]');
  var espKnoepfe = alle('[data-zo-esp]');
  var preise = alle('[data-zo-preis]');
  function espSetzen(an) {
    mitEsp = an;
    root.classList.toggle('mit-espresso', an);
    espKnoepfe.forEach(function (b) {
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
      var l = b.getAttribute(an ? 'data-aus' : 'data-an');
      if (l) b.setAttribute('aria-label', l);
    });
    preise.forEach(function (p) {
      var t = p.getAttribute(an ? 'data-mit' : 'data-ohne');
      if (t) p.textContent = t;
    });
    if (!an) {
      var k = root.querySelector('[data-zo-optional]');
      if (k) {
        k.classList.remove('ist-offen');
        alle('.zo-feld', k).forEach(function (f) { f.classList.remove('ist-offen'); });
      }
    }
    stand();
  }
  espKnoepfe.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      espSetzen(!mitEsp);
    });
  });

  /* ---------- Zeichnung: Hervorheben + Kurzinfo ---------- */
  var figur = root.querySelector('.zo-figur');
  var tip = root.querySelector('[data-zo-tip]');
  var maus = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var gruppen = {}, legs = {}, punkte = {};
  alle('.zo-gruppe').forEach(function (g) { gruppen[g.getAttribute('data-zo-nr')] = g; });
  alle('[data-zo-leg]').forEach(function (a) { legs[a.getAttribute('data-zo-leg')] = a; });
  alle('[data-zo-punkt]').forEach(function (p) { punkte[p.getAttribute('data-zo-punkt')] = p; });
  var aktiv = null, zu = null;

  function setze(nr, an) {
    var fn = an ? 'add' : 'remove';
    if (gruppen[nr]) gruppen[nr].classList[fn]('ist-an');
    if (legs[nr]) legs[nr].classList[fn]('ist-an');
    if (punkte[nr]) punkte[nr].classList[fn]('ist-an');
  }
  function aus() {
    if (zu) { clearTimeout(zu); zu = null; }
    if (aktiv === null) return;
    setze(aktiv, false);
    aktiv = null;
    figur.classList.remove('hat-aktiv');
    tip.hidden = true;
  }
  function spaeter() {
    if (zu) clearTimeout(zu);
    zu = setTimeout(aus, 240);
  }
  function tipZeigen(p, nr) {
    tip.querySelector('[data-zo-tip-nr]').textContent = ('0' + nr).slice(-2);
    tip.querySelector('[data-zo-tip-name]').textContent = p.getAttribute('data-name');
    tip.querySelector('[data-zo-tip-preis]').textContent = p.getAttribute('data-preis');
    tip.querySelector('[data-zo-tip-link]').setAttribute('href', p.getAttribute('data-url'));
    tip.hidden = false;
    var fw = figur.clientWidth;
    var x = p.offsetLeft, y = p.offsetTop;
    var tw = tip.offsetWidth, th = tip.offsetHeight;
    var links = Math.min(Math.max(x - tw / 2, 4), fw - tw - 4);
    var oben = y - th - 20;
    if (oben < 4) oben = y + 22;
    tip.style.left = links + 'px';
    tip.style.top = oben + 'px';
  }
  function an(nr) {
    if (zu) { clearTimeout(zu); zu = null; }
    if (aktiv === nr) return;
    if (aktiv !== null) setze(aktiv, false);
    aktiv = nr;
    setze(nr, true);
    figur.classList.add('hat-aktiv');
    if (punkte[nr]) tipZeigen(punkte[nr], nr);
  }

  Object.keys(punkte).forEach(function (nr) {
    var p = punkte[nr];
    if (maus) {
      p.addEventListener('mouseenter', function () { an(nr); });
      p.addEventListener('mouseleave', spaeter);
      p.addEventListener('click', function () { window.location.href = p.getAttribute('data-url'); });
    } else {
      p.addEventListener('click', function (e) {
        e.stopPropagation();
        if (aktiv === nr) aus(); else an(nr);
      });
    }
    p.addEventListener('focus', function () { an(nr); });
    p.addEventListener('blur', spaeter);
  });
  Object.keys(gruppen).forEach(function (nr) {
    if (!maus) return;
    gruppen[nr].addEventListener('mouseenter', function () { an(nr); });
    gruppen[nr].addEventListener('mouseleave', spaeter);
  });
  Object.keys(legs).forEach(function (nr) {
    var a = legs[nr];
    if (maus) {
      a.addEventListener('mouseenter', function () { an(nr); });
      a.addEventListener('mouseleave', spaeter);
    }
    a.addEventListener('click', function () {
      var k = document.getElementById('zo-teil-' + nr);
      if (!k) return;
      k.classList.add('ist-an');
      setTimeout(function () { k.classList.remove('ist-an'); }, 1800);
    });
  });
  tip.addEventListener('mouseenter', function () { if (zu) { clearTimeout(zu); zu = null; } });
  tip.addEventListener('mouseleave', spaeter);
  document.addEventListener('click', function (e) {
    if (!maus && aktiv !== null && !tip.contains(e.target)) aus();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') aus(); });
  window.addEventListener('resize', function () { if (aktiv !== null && punkte[aktiv]) tipZeigen(punkte[aktiv], aktiv); });

  /* ---------- Varianten je Teil ---------- */
  var kacheln = alle('[data-zo-teil]');
  function lese(k) {
    var v = [];
    try { v = JSON.parse(k.querySelector('[data-zo-v]').textContent); } catch (e) {}
    var sel = alle('select[data-zo-opt]', k);
    var werte = sel.map(function (s) { return s.value; });
    var fehlt = sel.filter(function (s) { return !s.value; });
    if (fehlt.length) return { fehlt: fehlt };
    for (var i = 0; i < v.length; i++) {
      var passt = true;
      for (var j = 0; j < werte.length; j++) {
        if (String(v[i].o[j]) !== werte[j]) { passt = false; break; }
      }
      if (passt) return v[i].a ? { id: v[i].id } : { nicht: sel };
    }
    return { nicht: sel };
  }
  function pruefe(k) {
    var r = lese(k);
    var m = k.querySelector('[data-zo-meldung]');
    if (r.nicht) { m.textContent = T.gibtsnicht || ''; m.hidden = false; }
    else { m.hidden = true; m.textContent = ''; }
    if (r.id || r.nicht) {
      k.classList.remove('ist-offen');
      alle('.zo-feld', k).forEach(function (f) { f.classList.remove('ist-offen'); });
    }
    return r;
  }
  kacheln.forEach(function (k) {
    alle('select[data-zo-opt]', k).forEach(function (s) {
      s.addEventListener('change', function () {
        var f = s.closest('.zo-feld');
        if (f && s.value) f.classList.remove('ist-offen');
        pruefe(k);
        stand();
      });
    });
  });

  /* ---------- Komplettes Outfit in den Warenkorb ---------- */
  var knoepfe = alle('[data-zo-add]');
  var stati = alle('[data-zo-status]');
  knoepfe.forEach(function (b) { b.setAttribute('data-txt', b.querySelector('span').textContent); });
  function status(t) { stati.forEach(function (s) { s.textContent = t || ''; }); }
  function sperren(ja) {
    knoepfe.forEach(function (b) {
      var txt = b.getAttribute('data-txt');
      b.disabled = ja;
      b.querySelector('span').textContent = ja ? (T.laedt || txt) : txt;
    });
  }
  knoepfe.forEach(function (b) {
    b.addEventListener('click', function () {
      var items = [], offen = [], erste = null;
      kacheln.forEach(function (k) {
        if (!mitEsp && k.hasAttribute('data-zo-optional')) return;
        var r = pruefe(k);
        if (r.id) { items.push({ id: r.id, quantity: 1 }); return; }
        offen.push(k.getAttribute('data-name'));
        k.classList.add('ist-offen');
        (r.fehlt || r.nicht || []).forEach(function (s) {
          var f = s.closest('.zo-feld');
          if (f) f.classList.add('ist-offen');
        });
        if (!erste) erste = k;
      });
      if (offen.length) {
        status((T.fehlt || '') + ' ' + offen.join(', '));
        erste.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var s = erste.querySelector('.zo-feld.ist-offen select');
        if (s) setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }, 650);
        return;
      }
      status('');
      sperren(true);
      fetch(root.getAttribute('data-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function () {
        window.location.href = root.getAttribute('data-cart');
      }).catch(function () {
        sperren(false);
        status(T.fehler || '');
      });
    });
  });

  /* ---------- 9.1: Stand „x von 7 gewaehlt“ ---------- */
  function stand() {
    if (!standEl) return;
    var n = 0, x = 0;
    kacheln.forEach(function (k) {
      if (!mitEsp && k.hasAttribute('data-zo-optional')) return;
      n++;
      if (lese(k).id) x++;
    });
    standEl.textContent = x >= n ? (T.alle || '') : (T.gewaehlt || '').replace('%x%', x).replace('%n%', n);
    if (leiste) leiste.classList.toggle('ist-komplett', x >= n);
  }
  stand();

  /* ---------- 9.1: Details je Kachel (Handy) ---------- */
  alle('[data-zo-mehr]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.closest('.zo-kachel');
      if (!k) return;
      var auf = k.classList.toggle('ist-auf');
      b.setAttribute('aria-expanded', auf ? 'true' : 'false');
    });
  });

  /* ---------- 29.09.: Zeichnung passt in die erste Sicht ---------- */
  var figurPlatz = function () {
    var f = root.querySelector('.zo-figur');
    if (!f) return;
    var oben = f.getBoundingClientRect().top + window.pageYOffset;
    var unten = window.innerWidth < 990 && leiste ? leiste.offsetHeight + 10 : 16;
    root.style.setProperty('--zo-rest', Math.round(oben + unten) + 'px');
  };
  figurPlatz();
  window.addEventListener('resize', figurPlatz);
  window.addEventListener('load', figurPlatz);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(figurPlatz);

  /* ---------- 9.1: feste Kaufleiste unten (alle Geraete, 29.09.) ---------- */
  if (leiste) {
    var imFluss = knoepfe.filter(function (b) { return !leiste.contains(b); });
    var imBild = function (e) {
      var r = e.getBoundingClientRect();
      return r.width > 0 && r.top >= 50 && r.bottom <= window.innerHeight;
    };
    var geplant = false;
    var leistePruefen = function () {
      geplant = false;
      var a = root.getBoundingClientRect();
      var an = a.top < window.innerHeight * 0.6 && a.bottom > window.innerHeight && !imFluss.some(imBild);
      leiste.classList.toggle('ist-an', an);
      document.documentElement.classList.toggle('zo-leiste-an', an);
    };
    var anstossen = function () { if (!geplant) { geplant = true; window.requestAnimationFrame(leistePruefen); } };
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    leistePruefen();
  }
})();